module.exports = __webpack_public_path__ + "img/dress_3.dedf7cc3.png";